import type { ApolloError } from '@lichtblick/apollo';

import { LogoutOnError } from './logoutOnError';
import { useApolloErrorEffect } from './useApolloErrorEffect';

export const useLogoutOnApolloError = (error: ApolloError | undefined) => {
  useApolloErrorEffect(error, LogoutOnError);
};
